import { PATH } from '@/constants/path';
import type { DeviceConfig } from '@/modules/Footer/utils/screenFooterItems';
import { getScreenFooterItems } from '@/modules/Footer/utils/screenFooterItems';
import { NavItem, NavItemId } from '@/types/navigation';

// The CMS "Doctors" subnav is expected to list this page, but it isn't guaranteed to — fall back
// to a static link so the page keeps an internal link and mobile users keep footer access to it
// regardless of CMS content.
const DOCTORS_STATIC_SUB_ITEMS: NavItem[] = [
  { label: 'Specialities in demand', to: PATH.DOCTORS_SPECIALITIES_IN_DEMAND },
];

export const getSubFooterItems = (navId: NavItemId | undefined, navItems: NavItem[]): NavItem[] => {
  const isAllowedNavId = navId === 'doctors_pages' || navId === 'about_us_pages';

  if (!isAllowedNavId || !navItems?.length) {
    return [];
  }

  const navItem = navItems.find(item => item.id === navId);
  const cmsSubItems = navItem?.subItems ?? [];

  if (navId !== 'doctors_pages') {
    return cmsSubItems;
  }

  const staticSubItems = DOCTORS_STATIC_SUB_ITEMS.filter(
    staticItem => !cmsSubItems.some(cmsItem => cmsItem.to === staticItem.to),
  );
  return [...cmsSubItems, ...staticSubItems];
};

export const getScreenMedia = (
  cmsNavItems: NavItem[],
  isMobile: boolean,
  isTablet: boolean,
): DeviceConfig => {
  const items = getScreenFooterItems(cmsNavItems);
  if (!isMobile && !isTablet) {
    return items.desktop;
  }
  return isMobile ? items.mobile : items.tablet;
};
